'use strict';
/* ============================================================
   L'INTERDIT v4 — Theme JavaScript
   ============================================================ */

// ── AGE GATE ──
const AgeGate = {
  init() {
    if (sessionStorage.getItem('li_age_ok')) return;
    const gate = document.getElementById('age-gate');
    if (!gate) return;
    gate.style.display = 'flex';
    document.body.classList.add('no-scroll');

    document.getElementById('age-confirm')?.addEventListener('click', () => {
      sessionStorage.setItem('li_age_ok', '1');
      gate.style.opacity = '0';
      gate.style.transition = 'opacity .5s ease';
      setTimeout(() => { gate.remove(); document.body.classList.remove('no-scroll'); }, 500);
    });
  }
};

// ── HEADER SCROLL ──
const HeaderScroll = {
  init() {
    const h = document.querySelector('.site-header');
    if (!h) return;
    window.addEventListener('scroll', () => {
      h.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }
};

// ── MOBILE MENU ──
const MobileMenu = {
  open: false,
  init() {
    this.btn     = document.getElementById('hamburger');
    this.panel   = document.getElementById('mobile-nav');
    this.overlay = document.getElementById('mnav-overlay');
    this.closeBtn= document.getElementById('mnav-close');
    if (!this.btn || !this.panel) return;

    this.btn.addEventListener('click', () => this.toggle());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    // Ferme sur clic lien
    this.panel.querySelectorAll('a').forEach(a => a.addEventListener('click', () => this.close()));

    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  },
  toggle() { this.open ? this.close() : this.openMenu(); },
  openMenu() {
    this.open = true;
    this.panel.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    this.btn.classList.add('is-open');
    this.btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
  },
  close() {
    this.open = false;
    this.panel.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    this.btn.classList.remove('is-open');
    this.btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
  }
};

// ── CART DRAWER ──
const Cart = {
  isOpen: false,
  init() {
    const drawer  = document.getElementById('cart-drawer');
    const overlay = drawer?.querySelector('.cart-drawer__overlay');
    const closeBtn= drawer?.querySelector('.cart-drawer__close');

    overlay?.addEventListener('click', () => this.close());
    closeBtn?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.isOpen) this.close(); });

    document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', () => this.open()));
  },
  open() {
    document.getElementById('cart-drawer')?.classList.add('is-open');
    document.body.classList.add('no-scroll');
    this.isOpen = true;
    this.render();
  },
  close() {
    document.getElementById('cart-drawer')?.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    this.isOpen = false;
  },
  async render() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      this.updateBadge(data.item_count);

      const el    = document.getElementById('cart-items');
      const total = document.getElementById('cart-total');
      if (total) total.textContent = this.money(data.total_price);

      // Indicateur de livraison offerte
      const fs = document.getElementById('fs-bar');
      if (fs) {
        const seuil = parseInt(fs.dataset.seuil, 10) || 0;
        const reste = seuil - data.total_price;
        const msg = document.getElementById('fs-msg');
        const fill = document.getElementById('fs-fill');
        if (msg) msg.innerHTML = reste > 0
          ? 'Plus que <strong>' + this.money(reste) + '</strong> pour la livraison offerte'
          : 'La livraison vous est offerte';
        if (fill) fill.style.width = Math.min(100, seuil ? data.total_price / seuil * 100 : 100) + '%';
        fs.classList.toggle('fs--ok', reste <= 0);
      }

      if (!el) return;
      if (!data.items.length) {
        el.innerHTML = `<div class="cart-empty"><p>Votre panier est vide</p><p>Découvrez notre collection</p></div>`;
        return;
      }
      el.innerHTML = data.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img class="cart-item__img" src="${item.image || ''}" alt="${item.title}">
          <div>
            <p class="cart-item__name">${item.product_title}</p>
            ${item.variant_title ? `<p class="cart-item__var">${item.variant_title}</p>` : ''}
            ${item.properties && item.properties['Message cadeau'] ? `<p class="cart-item__gift">Message cadeau : « ${String(item.properties['Message cadeau']).replace(/[<>&]/g, c => ({'<':'&lt;','>':'&gt;','&':'&amp;'}[c]))} »</p>` : ''}
            <p class="cart-item__price">${this.money(item.final_price)}</p>
            <div class="cart-item__qty">
              <button class="qty-btn" onclick="Cart.setQty('${item.key}',${item.quantity - 1})">−</button>
              <span class="qty-val">${item.quantity}</span>
              <button class="qty-btn" onclick="Cart.setQty('${item.key}',${item.quantity + 1})">+</button>
            </div>
          </div>
          <button class="cart-item__del" onclick="Cart.setQty('${item.key}',0)" aria-label="Supprimer">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>`).join('');
    } catch(e) { console.error('Cart render:', e); }
  },
  async setQty(key, qty) {
    try {
      const res  = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const data = await res.json();
      this.updateBadge(data.item_count);
      this.render();
    } catch(e) { console.error('Cart setQty:', e); }
  },
  updateBadge(n) {
    document.querySelectorAll('.cart-badge').forEach(el => {
      const avant = parseInt(el.textContent, 10) || 0;
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
      // Le compteur réagit discrètement quand le panier augmente
      if (n > avant) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  },
  money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }
};

// ── ADD TO CART ──
const AddToCart = {
  init() {
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const fd  = new FormData(form);
        btn.disabled = true;
        const orig = btn.textContent;
        btn.textContent = 'Ajout…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify((() => {
              // Transmet aussi les propriétés de ligne (ex. « Message cadeau »),
              // en ignorant les champs laissés vides.
              const item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || 1) };
              const props = {};
              for (const [k, v] of fd.entries()) {
                const m = k.match(/^properties\[(.+)\]$/);
                if (m && String(v).trim()) props[m[1]] = String(v).trim();
              }
              if (Object.keys(props).length) item.properties = props;
              return item;
            })())
          });
          if (res.ok) {
            const cartRes  = await fetch('/cart.js');
            const cartData = await cartRes.json();
            Cart.updateBadge(cartData.item_count);
            // L'ouverture du tiroir confirme l'ajout : pas de notification
            // par-dessus (elle masquait le bouton Commander sur mobile).
            Cart.open();
            btn.textContent = '✓ Ajouté';
            setTimeout(() => { btn.disabled = false; btn.textContent = orig; }, 2200);
          } else {
            throw new Error('add failed');
          }
        } catch {
          btn.disabled = false;
          btn.textContent = 'Réessayer';
        }
      });
    });
  }
};

// ── QUANTITY SELECTOR ──
const QtySelector = {
  init() {
    document.querySelectorAll('.qty-selector').forEach(sel => {
      const input = sel.querySelector('input');
      sel.querySelector('[data-dec]')?.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
      });
      sel.querySelector('[data-inc]')?.addEventListener('click', () => {
        input.value = (parseInt(input.value) || 1) + 1;
      });
    });
  }
};

// ── PRODUCT GALLERY ──
const Gallery = {
  init() {
    const main   = document.querySelector('.gallery__main img');
    const thumbs = document.querySelectorAll('.gallery__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(th => {
      th.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        th.classList.add('active');
        // On utilise l'URL haute résolution stockée dans data-full
        const fullSrc = th.getAttribute('data-full');
        const thumbSrc = th.querySelector('img')?.src;
        if (fullSrc) {
          main.src = fullSrc;
        } else if (thumbSrc) {
          main.src = thumbSrc;
        }
      });
    });
  }
};

// ── VARIANT SELECT (taille, couleur, etc.) ──
const Variants = {
  init() {
    const select = document.getElementById('variantSelect');
    if (!select) return; // Pas de variantes sur ce produit

    document.querySelectorAll('.variant-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        // 1. Marquer cette option comme active dans son groupe
        const group = btn.closest('.variant-options');
        group?.querySelectorAll('.variant-opt').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // 2. Mettre à jour le label "Couleur : Rouge"
        const optionPos = btn.dataset.option;
        const value = btn.dataset.value;
        const currentLabel = document.querySelector(`.variant-current[data-option="${optionPos}"]`);
        if (currentLabel) currentLabel.textContent = value;

        // 3. Récupérer toutes les options actives pour trouver la bonne variante
        const activeValues = [];
        document.querySelectorAll('.variant-options').forEach(grp => {
          const active = grp.querySelector('.variant-opt.active');
          if (active) activeValues.push(active.dataset.value);
        });

        // 4. Trouver l'option <select> qui correspond à toutes les valeurs choisies
        const options = select.querySelectorAll('option');
        for (let opt of options) {
          const optVals = opt.dataset.options?.split(',') || [];
          if (activeValues.length === optVals.length &&
              activeValues.every((v, i) => v === optVals[i])) {
            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }

        // 5. Si une image variant existe, la charger
        // (Shopify auto-détecte ça via les couleurs si elles ont des images associées)
      });
    });
  }
};

// ── WISHLIST ──
/* Favoris retirés en v39 : le bouton n'enregistrait rien. */
const Wishlist = { init() {} };

// ── TOAST ──
const Toast = {
  timer: null,
  show(msg, duration = 2800) {
    const el = document.getElementById('toast');
    if (!el) return;
    el.querySelector('.toast__msg').textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(this.timer);
    this.timer = setTimeout(() => el.classList.remove('is-visible'), duration);
  }
};

// ── NEWSLETTER ──
/* Newsletter : envoi natif Shopify (snippets/newsletter-form.liquid) — plus d'interception JS. */
const Newsletter = { init() {} };

// ── SCROLL ANIMATIONS ──
const ScrollAnim = {
  init() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-in').forEach(el => obs.observe(el));
  }
};


// ── MODE DISCRET ──
// Voile les photos (produits, hero, univers, panier) pour naviguer en public.
// Mémorisé sur l'appareil. L'onglet affiche simplement « L'Interdit ».
// Sur une fiche produit, « Afficher les photos » dévoile ce produit seulement,
// sans désactiver le mode pour la suite de la navigation.
const Discret = {
  KEY: 'li_discret',
  title: document.title,
  on() { return document.documentElement.classList.contains('is-discret'); },
  set(active, announce) {
    const html = document.documentElement;
    html.classList.toggle('is-discret', active);
    html.classList.remove('discret-peek');
    try { active ? localStorage.setItem(this.KEY, '1') : localStorage.removeItem(this.KEY); } catch (e) {}
    this.sync();
    if (announce) Toast.show(active ? 'Mode discret activé — photos voilées' : 'Mode discret désactivé');
  },
  sync() {
    const active = this.on();
    document.querySelectorAll('[data-discret-toggle]').forEach(b => {
      b.setAttribute('aria-pressed', String(active));
      b.classList.toggle('is-on', active);
    });
    document.title = active ? "L'Interdit" : this.title;
  },
  init() {
    document.querySelectorAll('[data-discret-toggle]').forEach(b =>
      b.addEventListener('click', () => this.set(!this.on(), true)));
    document.querySelectorAll('[data-discret-peek]').forEach(b =>
      b.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        document.documentElement.classList.add('discret-peek');
      }));
    // Entrée sur le site directement en mode discret, depuis l'écran 18+
    document.getElementById('age-confirm-discret')?.addEventListener('click', () => {
      this.set(true, false);
      document.getElementById('age-confirm')?.click();
    });
    this.sync();
  }
};

// ── INIT ──
// Chaque module est isolé : si l'un échoue (élément absent d'une page),
// les autres continuent de fonctionner au lieu de tomber en cascade.
document.addEventListener('DOMContentLoaded', () => {
  const modules = { AgeGate, HeaderScroll, MobileMenu, Cart, AddToCart, QtySelector,
                    Gallery, Variants, Wishlist, Newsletter, ScrollAnim, Lightbox, Discret, Intent };
  for (const [name, mod] of Object.entries(modules)) {
    try { mod && mod.init && mod.init(); }
    catch (e) { console.warn('[L\'Interdit] module ' + name + ' :', e.message); }
  }
});

// ── LIGHTBOX (zoom photos produit) ──
const Lightbox = {
  images: [],
  currentIndex: 0,

  init() {
    const lightbox = document.getElementById('lightbox');
    if (!lightbox) return;

    const lbImg     = document.getElementById('lightboxImg');
    const lbClose   = document.getElementById('lightboxClose');
    const lbPrev    = document.getElementById('lightboxPrev');
    const lbNext    = document.getElementById('lightboxNext');
    const lbCounter = document.getElementById('lightboxCounter');

    // Récolte toutes les images zoomables sur la page produit
    this.collectImages();

    if (this.images.length === 0) return;

    // Image principale cliquable → ouvre le lightbox
    const mainContainer = document.querySelector('.gallery__main');
    if (mainContainer) {
      mainContainer.addEventListener('click', () => {
        if (Discret.on() && !document.documentElement.classList.contains('discret-peek')) {
          document.documentElement.classList.add('discret-peek'); return;
        }
        const mainImg = document.getElementById('gallery-main-img');
        const currentSrc = mainImg?.src;
        const idx = this.images.findIndex(src => src === currentSrc);
        this.open(idx >= 0 ? idx : 0);
      });
    }

    // Navigation
    lbClose.addEventListener('click', () => this.close());
    lbPrev.addEventListener('click', () => this.prev());
    lbNext.addEventListener('click', () => this.next());

    // Click sur fond noir = fermer
    lightbox.addEventListener('click', e => {
      if (e.target === lightbox) this.close();
    });

    // Clavier
    document.addEventListener('keydown', e => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });

    // Swipe sur mobile
    let touchStartX = 0;
    lightbox.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.prev(); else this.next();
      }
    });
  },

  collectImages() {
    this.images = [];
    // Récupère les URLs haute résolution depuis data-full des miniatures
    document.querySelectorAll('.gallery__thumb').forEach(th => {
      const full = th.getAttribute('data-full');
      if (full) this.images.push(full);
    });
    // Si pas de miniatures, prendre l'image principale
    if (this.images.length === 0) {
      const mainImg = document.getElementById('gallery-main-img');
      if (mainImg?.src) this.images.push(mainImg.src);
    }
  },

  open(index) {
    if (this.images.length === 0) return;
    const lightbox = document.getElementById('lightbox');
    this.currentIndex = Math.max(0, Math.min(index, this.images.length - 1));
    this.render();
    lightbox.classList.add('is-open');
    document.body.classList.add('lightbox-open');
  },

  close() {
    const lightbox = document.getElementById('lightbox');
    lightbox.classList.remove('is-open');
    document.body.classList.remove('lightbox-open');
  },

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.render();
    }
  },

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
      this.render();
    }
  },

  render() {
    const lbImg     = document.getElementById('lightboxImg');
    const lbCounter = document.getElementById('lightboxCounter');
    const lbPrev    = document.getElementById('lightboxPrev');
    const lbNext    = document.getElementById('lightboxNext');

    lbImg.src = this.images[this.currentIndex];
    lbCounter.textContent = `${this.currentIndex + 1} / ${this.images.length}`;

    lbPrev.classList.toggle('is-disabled', this.currentIndex === 0);
    lbNext.classList.toggle('is-disabled', this.currentIndex === this.images.length - 1);

    // Cache les boutons nav s'il n'y a qu'une image
    if (this.images.length <= 1) {
      lbPrev.style.display = 'none';
      lbNext.style.display = 'none';
      lbCounter.style.display = 'none';
    }
  }
};

// ── CODE PROMO DRAWER ──
const PromoCode = {
  init() {
    const toggle = document.getElementById('cartPromoToggle');
    const field  = document.getElementById('cartPromoField');
    const block  = document.getElementById('cartPromoBlock');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const open = field.style.display === 'none';
      field.style.display = open ? 'block' : 'none';
      block.classList.toggle('open', open);
    });
  }
};

async function applyPromo() {
  const input = document.getElementById('promoInput');
  const msg   = document.getElementById('promoMsg');
  const btn   = document.getElementById('promoApply');
  const code  = input?.value.trim().toUpperCase();
  if (!code) return;

  btn.disabled = true;
  btn.textContent = '…';
  msg.style.display = 'none';

  try {
    // Appliquer le code via l'API cart Shopify
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    // Rediriger vers /cart pour voir la réduction appliquée par Shopify
    window.location.href = '/cart?discount=' + encodeURIComponent(code);
  } catch(e) {
    msg.textContent = 'Impossible d\'appliquer le code. Réessayez.';
    msg.className = 'promo-msg--err';
    msg.style.display = 'block';
    btn.disabled = false;
    btn.textContent = 'Appliquer';
  }
}

// Ajouter init dans DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  PromoCode.init();
});

// ── RECHERCHE PAR INTENTION ──
// Shopify cherche des mots exacts : « cadeau pour elle » ne trouve rien.
// Cette couche reconnaît l'intention et oriente vers la bonne collection ou le
// bon guide. Elle ne propose jamais une collection vide, et reste honnête quand
// un produit n'est pas encore vendu. Aperçu en direct pendant la saisie.
const Intent = {
  norm(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
  },
  // e = mots exacts · p = débuts de mots (« debut » reconnaît « débutante »)
  RULES: [
    { id:'cadeau',  p:['cadeau','offrir','anniv','valentin','noel','surprise'] },
    { id:'elle',    e:['elle','femme','femmes','feminin','feminine','copine','epouse'] },
    { id:'lui',     e:['lui','homme','hommes','masculin','copain','mari'] },
    { id:'deux',    e:['couple','couples','deux','duo','partenaire'], p:['telecommand','distance','connect'] },
    { id:'debut',   p:['debut','premier','premiere','decouv','novice','commenc','initiat'] },
    { id:'discret', p:['discre','silenc','anonym','colis','emballage','facteur'] },
    { id:'lubri',   p:['lubri'], e:['gel'] },
    { id:'doux',    p:['doux','douce','douceur','sensible','delicat','silicone'] },
    { id:'linger',  p:['linger','string','nuisette','soutien','culotte','corset','dentelle'], e:['body'] },
    { id:'vibro',   p:['vibro','rabbit','stimul'] },
    { id:'soin',    p:['nettoy','entretien','laver','hygien','conserv','ranger'] },
    { id:'livr',    p:['livraison','delai','expedi'], e:['frais','port'] },
    { id:'retour',  p:['retour','rembours','echang'] }
  ],
  match(q) {
    const words = this.norm(q), found = [];
    for (const r of this.RULES) {
      const hit = words.some(w => (r.e || []).includes(w) || (r.p || []).some(k => w.startsWith(k)));
      if (hit) found.push(r.id);
    }
    return found;
  },
  card(id, d) {
    const col = h => d.col[h] && d.col[h].n > 0 ? d.col[h].url : null;
    const pg  = (h, a) => d.page[h] ? d.page[h] + (a ? '#' + a : '') : null;
    const L = (t, u) => u ? { t, u } : null;
    const C = {
      cadeau:  { t:'Une idée cadeau ?', x:'Sur chaque fiche produit, ajoutez un message personnalisé : il est glissé sous enveloppe fermée dans le colis.',
                 l:[L('Pour elle', col('pour-elle')), L('À deux', col('couples')), L('Nouveautés', col('nouveautes'))] },
      elle:    { t:'Pour elle', x:'Notre sélection pensée pour le plaisir féminin.', l:[L('Découvrir la sélection', col('pour-elle'))] },
      lui:     col('pour-lui')
               ? { t:'Pour lui', x:'Notre sélection pensée pour le plaisir masculin.', l:[L('Découvrir la sélection', col('pour-lui'))] }
               : { t:'Pour lui', x:'Notre sélection pour lui arrive bientôt. En attendant, découvrez nos pièces à partager.', l:[L('À deux', col('couples')), L('Tous les produits', '/collections/all')] },
      deux:    { t:'À deux', x:'Des pièces pensées pour se découvrir ensemble, et nos conseils pour en parler sereinement.',
                 l:[L('La sélection à deux', col('couples')), L('Nos conseils couple', pg('couples-intimite'))] },
      debut:   { t:'Une première fois ?', x:'Nos conseils pour choisir sereinement : matériaux, taille, sensations. Sans jargon, sans jugement.',
                 l:[L('Bien débuter', pg('bien-debuter', 'premier-sextoy')), L('Tous les produits', '/collections/all')] },
      discret: { t:'Discrétion', x:'Colis opaque, contenu jamais détaillé à l’extérieur, mention bancaire sobre.',
                 l:[L('Comment nous expédions', pg('livraison-discretion')), L('Livraison', pg('livraison'))] },
      lubri:   { t:'Lubrifiants', x:'Ils ne font pas encore partie de notre sélection. Notre guide vous aide à bien les choisir selon vos produits.',
                 l:[L('Bien choisir son lubrifiant', pg('guides-achat', 'lubrifiant'))] },
      doux:    { t:'Douceur', x:'Le silicone offre un toucher particulièrement doux. Les matières de chaque produit sont indiquées sur sa fiche.',
                 l:[L('Comprendre les matériaux', pg('guides-achat', 'vibromasseur')), L('Pour elle', col('pour-elle'))] },
      linger:  col('lingerie')
               ? { t:'Lingerie', x:'Notre sélection de lingerie.', l:[L('Découvrir', col('lingerie'))] }
               : { t:'Lingerie', x:'Notre première collection de lingerie est en préparation.', l:[L('Nouveautés', col('nouveautes')), L('Tous les produits', '/collections/all')] },
      vibro:   { t:'Bien choisir', x:'Forme, puissance, niveau sonore : nos repères pour trouver le modèle qui vous correspond.',
                 l:[L('Comment choisir un vibromasseur', pg('guides-achat', 'vibromasseur'))] },
      soin:    { t:'Entretien', x:'Nettoyer, sécher, ranger : les bons gestes pour faire durer vos produits.', l:[L('Nos conseils d’entretien', pg('entretien-conseils', 'nettoyer'))] },
      livr:    { t:'Livraison', x:'Délais, tarifs et discrétion de l’envoi.', l:[L('Tout sur la livraison', pg('livraison'))] },
      retour:  { t:'Retours', x:'Conditions, délais et procédure de remboursement.', l:[L('Retours et remboursements', pg('retours'))] }
    }[id];
    if (!C) return null;
    C.l = C.l.filter(Boolean);
    return C.l.length ? C : null;
  },
  fallback(d) {
    const links = [['Pour elle','pour-elle'],['Pour lui','pour-lui'],['À deux','couples'],['Lingerie','lingerie'],['Nouveautés','nouveautes']]
      .filter(([, h]) => d.col[h] && d.col[h].n > 0).map(([t, h]) => ({ t, u: d.col[h].url }));
    links.push({ t: 'Tous les produits', u: '/collections/all' });
    return { t: 'Laissez-vous guider', x: 'Parcourez nos univers, ou décrivez simplement ce que vous cherchez : « cadeau », « à deux », « première fois »…', l: links };
  },
  esc(t) { return String(t).replace(/[&<>"]/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c])); },
  render(box, d, q, live) {
    // Une destination n'est proposée qu'une fois ; une carte sans lien nouveau est retirée.
    const seen = new Set();
    let cards = this.match(q).map(id => this.card(id, d)).filter(Boolean).map(c => {
      c.l = c.l.filter(l => !seen.has(l.u) && seen.add(l.u));
      return c;
    }).filter(c => c.l.length).slice(0, 2);
    if (!cards.length && !live && q && d.count === 0) cards = [this.fallback(d)];
    if (!cards.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = '<p class="intent__eyebrow">L’Interdit vous oriente</p><div class="intent__grid">' +
      cards.map(c => '<div class="intent__card"><p class="intent__title">' + this.esc(c.t) + '</p><p class="intent__text">' +
        this.esc(c.x) + '</p><div class="intent__links">' +
        c.l.map(l => '<a class="intent__link" href="' + this.esc(l.u) + '">' + this.esc(l.t) + ' <span aria-hidden="true">→</span></a>').join('') +
        '</div></div>').join('') + '</div>';
    box.hidden = false;
  },
  init() {
    const box = document.getElementById('intent-box'), raw = document.getElementById('intent-data');
    if (!box || !raw) return;
    let d; try { d = JSON.parse(raw.textContent); } catch (e) { return; }
    this.render(box, d, d.q, false);
    const input = document.getElementById('search-q');
    let t;
    input?.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => this.render(box, d, input.value, input.value !== d.q), 180);
    });
  }
};
